"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ClickAwayListener;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// This component wraps the children in a div in order to get a reference to
// the children. This is the recommended approach, however ideally we don't
// want it to change the structure. This can be revisited if it becomes a
// problem. See more here:
// https://18.react.dev/reference/react-dom/findDOMNode#adding-a-wrapper-div-element
// https://github.com/facebook/react/issues/14357

function ClickAwayListener(_ref) {
  var children = _ref.children,
    onClickAway = _ref.onClickAway;
  var containerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var handleClick = function handleClick(e) {
      var _containerRef$current;
      if (!((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target))) {
        onClickAway === null || onClickAway === void 0 || onClickAway();
      }
    };

    // If the user conditionally renders this element with a click,
    // wrapping it in a setTimeout prevents it from triggering the
    // clickAway immediately.
    var timeout = setTimeout(function () {
      window.addEventListener('click', handleClick);
    }, 0);
    return function () {
      clearTimeout(timeout);
      window.removeEventListener('click', handleClick);
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: containerRef,
    children: children
  });
}